import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { from, Subject } from 'rxjs';
import { StepIds } from '../../../models/motors-step/motors-step-model';
import { MotorsDraftFacade, UserFacade } from '@classifieds-sell/state';
import { MotorsSectionBase } from '../../motors-section-base';
import { takeUntil } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { getSummarySectionLinkText } from '../../../helpers/summary-page.helper';

@Component({
    selector: 'motors-summary-page-contact-details-section',
    templateUrl: './summary-page-contact-details-section.component.html',
    styleUrls: ['./summary-page-contact-details-section.component.scss'],
    standalone: false
})
export class SummaryPageContactDetailsSectionComponent
    extends MotorsSectionBase
    implements OnInit, OnDestroy {
    stepIds = StepIds;

    mobileNumber: string;
    landlineNumber: string;

    displayMobileNumber: boolean;
    displayLandlineNumber: boolean;
    summarySectionLinkText: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: MotorsDraftFacade,
        private _userFacade: UserFacade,
        private route: ActivatedRoute,
        private _changeDetectorRef: ChangeDetectorRef
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            from(this._userFacade.memberSummary$)
                .pipe(takeUntil(this._destroyed$))
                .subscribe((memberSummary) => {
                    this.mobileNumber = memberSummary.mobilePhoneNumber;
                    this.landlineNumber = memberSummary.landlinePhoneNumber;

                    this.displayMobileNumber = this.draftData.listingDetails.displayMobileNumber;
                    this.displayLandlineNumber = this.draftData.listingDetails.displayLandlineNumber;
                    this.summarySectionLinkText = getSummarySectionLinkText(this.route);

                    this._changeDetectorRef.markForCheck();
                });
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }
}
